<template>
    <el-dialog
            :title="setId?'绑定设备':'绑定设备'"
            :visible.sync="dialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="600px"
            center>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
            <el-form-item label="设备类型" prop="type">
                <el-select v-model="ruleForm.type" filterable placeholder="请选择设备类型" style="width: 100%">
                    <el-option
                        v-for="item in devTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设备名称" prop="name">
                <el-input v-model="ruleForm.name" placeholder="请输入设备名称"></el-input>
            </el-form-item>
            <el-form-item label="设备编号" prop="dev_id">
                <el-input v-model="ruleForm.dev_id" placeholder="请输入设备编号"></el-input>
            </el-form-item>
            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('ruleForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('ruleForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>

import {devTypeList} from "@/utils/utils";
import {bdingDevice} from "@/api/houst";

export default {
    name: "SafetyDevDialog",
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        setId: {
            type: Number,
            default() {
                return 0;
            }
        },
        room_id: {
            type: [Number,String],
            default:''
        },
        setItem: {
            type: Object
        }
    },
    data() {

        return {
            devTypeList:devTypeList,
            ruleForm: {
                name:'',// '名称',
                dev_id:'',//'设备码',
                type:'',//绑定类型：1水浸传感器 2烟雾传感器 3人体跌倒
            },
            rules: {
                type: [{required: true, message: '请选择设备类型', trigger: 'change'}],
                name: [{required: true, message: '请输入设备名称', trigger: 'blur'}],
                dev_id: [{required: true, message: '请输入设备编号', trigger: 'blur'}],
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },

    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await bdingDevice(
                this.setId,
                this.room_id,
                this.ruleForm.name,
                this.ruleForm.dev_id,
                this.ruleForm.type,
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        }

    },
    watch: {
        setItem() {
            this.ruleForm = {
                type: this.setItem.type ? Number(this.setItem.type) : '',
                name: this.setItem.name,
                dev_id: this.setItem.dev_id,
            };
        },
    }
}
</script>

<style scoped lang="scss">

</style>
